import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  min-height: 100vh;
  justify-content: center;
  align-items: center;
  padding: 28px;
  background:
    radial-gradient(
      circle at 12% 18%,
      rgba(110, 185, 160, 0.18),
      transparent 28%
    ),
    radial-gradient(
      circle at 88% 8%,
      rgba(53, 109, 159, 0.16),
      transparent 30%
    ),
    linear-gradient(180deg, #f5fbf8 0%, #edf3fb 100%);

  @media (max-width: 768px) {
    padding: 14px;
  }
`;

export const AuthShell = styled.div`
  width: 100%;
  max-width: 1080px;
  display: grid;
  grid-template-columns: minmax(320px, 0.92fr) minmax(380px, 0.88fr);
  border-radius: 28px;
  overflow: hidden;
  box-shadow: 0 28px 70px rgba(18, 62, 51, 0.14);
  border: 1px solid rgba(24, 90, 66, 0.08);
  background: #ffffff;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
  }
`;

export const BrandPanel = styled.div`
  padding: 40px 36px;
  background:
    radial-gradient(
      circle at 20% 18%,
      rgba(255, 255, 255, 0.12),
      transparent 28%
    ),
    linear-gradient(145deg, #155d4b 0%, #1f725f 58%, #356d9f 100%);
  color: #ffffff;
  display: grid;
  align-content: center;
  gap: 28px;

  .brand-badge {
    width: fit-content;
    padding: 8px 14px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.18);
    font-size: 0.76rem;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    font-weight: 700;
    color: rgba(248, 255, 250, 0.86);
  }

  @media (max-width: 960px) {
    padding: 28px 22px;
    gap: 20px;
  }
`;

export const LoginPanel = styled.div`
  padding: 40px 36px;
  background: linear-gradient(180deg, #ffffff 0%, #fbfefd 100%);
  display: grid;
  align-content: center;
  gap: 26px;

  @media (max-width: 960px) {
    padding: 26px 20px 24px;
  }
`;

export const ContainerTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;

  .ant-avatar {
    flex-shrink: 0;
    box-shadow: 0 14px 32px rgba(8, 31, 26, 0.18);
  }

  .ant-typography {
    color: #f8fff9;
    margin-bottom: 0;
  }

  h2.ant-typography {
    margin-bottom: 6px;
    color: #ffffff;
  }

  p.ant-typography {
    color: rgba(241, 255, 248, 0.82);
    line-height: 1.7;
    max-width: 32ch;
  }

  @media (max-width: 640px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 14px;
  }
`;

export const LoginHeader = styled.div`
  display: grid;
  grid-template-columns: 56px 1fr;
  gap: 16px;
  align-items: center;

  .icon-box {
    width: 56px;
    height: 56px;
    border-radius: 18px;
    display: grid;
    place-items: center;
    color: #1f725f;
    background: linear-gradient(
      135deg,
      rgba(31, 114, 95, 0.12),
      rgba(53, 109, 159, 0.12)
    );
    font-size: 24px;
  }

  .eyebrow {
    display: inline-block;
    margin-bottom: 4px;
    font-size: 0.76rem;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #6d9283;
    font-weight: 700;
  }

  h3.ant-typography {
    margin-bottom: 4px;
    color: #143d30;
  }

  p.ant-typography {
    margin-bottom: 0;
    color: #5b7d6f;
    line-height: 1.6;
  }
`;

export const LoginFormWrap = styled.div`
  padding: 24px;
  border-radius: 22px;
  border: 1px solid rgba(24, 90, 66, 0.08);
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(18, 62, 51, 0.06);

  .ant-form-item-label > label {
    font-weight: 600;
    color: #1e4f3c;
  }

  .ant-form-item-extra {
    color: #6f8f82;
    font-size: 0.79rem;
  }

  .ant-input,
  .ant-input-password,
  .ant-input-affix-wrapper {
    border-radius: 14px;
    border-color: rgba(24, 90, 66, 0.18);
    min-height: 48px;
  }

  .ant-input-affix-wrapper:focus,
  .ant-input-affix-wrapper-focused,
  .ant-input:focus {
    border-color: #1f725f;
    box-shadow: 0 0 0 3px rgba(31, 114, 95, 0.1);
  }

  .login-form-button {
    height: 48px;
    border-radius: 14px;
    font-size: 1rem;
    font-weight: 700;
    background: linear-gradient(120deg, #165e47 0%, #2f5d89 100%);
    border: none;
    box-shadow: 0 14px 28px rgba(25, 89, 68, 0.16);
  }

  @media (max-width: 640px) {
    padding: 18px;
    border-radius: 18px;
  }
`;

export const SupportList = styled.ul`
  list-style: none;
  display: grid;
  gap: 12px;

  li {
    padding: 14px 16px;
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.14);
  }

  strong {
    display: block;
    margin-bottom: 4px;
    color: #ffffff;
    font-size: 0.96rem;
  }

  span {
    color: rgba(241, 255, 248, 0.8);
    line-height: 1.55;
    font-size: 0.9rem;
  }
`;
